import { PET_SUPPLIES_SECTIONS } from './petSuppliesCategorySchema';
import { PET_TYPES } from './petSuppliesCategorySchema';
import {
  BOOK_SECTIONS,
  BOOK_TYPES,
  BOOK_LANGUAGES,
  BOOK_AUDIENCES,
} from './booksCategorySchema';
import { PRE_OWNED_ITEM_CATEGORY_DATA } from './preOwnedItemCategories';

export { BOOK_SECTIONS, BOOK_TYPES, BOOK_LANGUAGES, BOOK_AUDIENCES };
export { PET_TYPES };

export const SHOP_DEPARTMENTS = ['Men', 'Women', 'Kids', 'Babies'];

export const FILTER_CONDITIONS = [
  'New',
  'Like New',
  'Excellent',
  'Good',
  'Fair',
  'Used',
  'Poor',
];

export const FILTER_COLOR_GROUPS = {
  Neutrals: [
    'Black',
    'White',
    'Off White',
    'Ivory',
    'Cream',
    'Beige',
    'Sand',
    'Stone',
    'Taupe',
    'Camel',
    'Tan',
    'Khaki',
    'Brown',
    'Chocolate Brown',
    'Coffee',
    'Mocha',
    'Espresso',
    'Gray',
    'Light Gray',
    'Charcoal',
    'Silver',
  ],
  Blue: [
    'Blue',
    'Navy',
    'Midnight Blue',
    'Royal Blue',
    'Cobalt Blue',
    'Sapphire Blue',
    'Denim Blue',
    'Sky Blue',
    'Baby Blue',
    'Powder Blue',
    'Steel Blue',
    'Teal Blue',
    'Turquoise',
    'Aqua',
    'Cyan',
  ],
  Green: [
    'Green',
    'Olive',
    'Army Green',
    'Khaki Green',
    'Sage Green',
    'Mint',
    'Seafoam',
    'Emerald',
    'Forest Green',
    'Hunter Green',
    'Lime',
    'Apple Green',
    'Moss Green',
    'Jade',
    'Pistachio',
    'Neon Green',
  ],
  Red: [
    'Red',
    'Scarlet',
    'Crimson',
    'Cherry Red',
    'Ruby',
    'Burgundy',
    'Wine',
    'Maroon',
    'Brick Red',
    'Rust',
    'Coral',
    'Tomato Red',
  ],
  Pink: [
    'Pink',
    'Baby Pink',
    'Blush Pink',
    'Dusty Pink',
    'Rose Pink',
    'Hot Pink',
    'Fuchsia',
    'Magenta',
    'Bubblegum Pink',
    'Salmon',
    'Peach',
    'Coral Pink',
  ],
  Purple: [
    'Purple',
    'Lavender',
    'Lilac',
    'Violet',
    'Plum',
    'Eggplant',
    'Mauve',
    'Orchid',
    'Grape',
    'Deep Purple',
  ],
  Yellow: [
    'Yellow',
    'Lemon',
    'Mustard',
    'Golden Yellow',
    'Amber',
    'Honey',
    'Butter Yellow',
    'Canary Yellow',
    'Neon Yellow',
  ],
  Orange: [
    'Orange',
    'Burnt Orange',
    'Tangerine',
    'Apricot',
    'Peach Orange',
    'Pumpkin',
    'Copper',
    'Terracotta',
  ],
  Metallics: [
    'Gold',
    'Rose Gold',
    'Silver',
    'Bronze',
    'Copper',
    'Metallic Blue',
    'Metallic Green',
    'Metallic Pink',
  ],
  'Special / Fashion Colors': [
    'Nude',
    'Champagne',
    'Pearl',
    'Oyster',
    'Smoke',
    'Ash',
    'Graphite',
    'Ice Blue',
    'Mint Cream',
    'Dusty Blue',
    'Dusty Green',
    'Dusty Rose',
    'Olive Drab',
  ],
};

export const FILTER_COLORS = [...new Set(Object.values(FILTER_COLOR_GROUPS).flat())];

export const FILTER_MATERIALS = [
  'Cotton',
  'Organic Cotton',
  'Linen',
  'Silk',
  'Satin',
  'Chiffon',
  'Velvet',
  'Lace',
  'Mesh',
  'Tulle',
  'Organza',
  'Denim',
  'Leather',
  'Faux Leather',
  'Suede',
  'Wool',
  'Cashmere',
  'Polyester',
  'Nylon',
  'Acrylic',
  'Rayon',
  'Viscose',
  'Modal',
  'Lyocell',
  'Spandex',
  'Knit',
  'Jersey',
  'Rib Knit',
  'Fleece',
  'Flannel',
  'Corduroy',
  'Tweed',
  'Canvas',
  'Poplin',
  'Crepe',
];

export const FILTER_LENGTH_GROUPS = {
  Tops: ['Cropped', 'Regular', 'Long'],
  Dresses: [
    'Micro',
    'Mini',
    'Above Knee',
    'Knee Length',
    'Midi',
    'Maxi',
    'Floor Length',
  ],
  Pants: ['Shorts', 'Bermuda', 'Capri', 'Ankle', 'Full Length'],
};

export const FILTER_LENGTHS = Object.values(FILTER_LENGTH_GROUPS).flat();

export const FILTER_CLOTHING_SIZES = [
  'XXS',
  'XS',
  'S',
  'M',
  'L',
  'XL',
  'XXL',
  '3XL',
  '0',
  '2',
  '4',
  '6',
  '8',
  '10',
  '12',
  '14',
  '16',
  '18',
  '20',
  '22',
  '34',
  '36',
  '38',
  '40',
  '42',
  '44',
  '46',
  '48',
  '50',
  '52',
  '35',
  '36',
  '37',
  '38',
  '39',
  '40',
  '41',
  '42',
  '43',
  '44',
  '45',
  'One Size',
];

export const BROWSE_CATEGORY_SUBCATEGORIES = {
  Books: BOOK_SECTIONS,
  Stationary: [
    'Notebooks & Journals',
    'Pens & Pencils',
    'Art Supplies',
    'School Supplies',
    'Office Supplies',
    'Planners & Calendars',
    'Files & Folders',
    'Calculators',
    'Desk Accessories',
  ],
  'Musical Instruments': [
    'Guitars & Basses',
    'Keyboards & Pianos',
    'Drums & Percussion',
    'Wind & Brass',
    'String Instruments',
    'DJ & Recording Equipment',
    'Amplifiers & Effects',
    'Accessories & Parts',
  ],
  Clothing: ['Men', 'Women', 'Kids', 'Babies'],
  Footwear: ['Men', 'Women', 'Kids'],
  Bags: ['Men', 'Women', 'Kids'],
  Accessories: ['Men', 'Women', 'Kids'],
  Watches: ['Analog', 'Digital', 'Smartwatch', 'Sport', 'Other'],
  Sports: ['Outdoor Recreation', 'Sports & Fitness', 'Team Sports', 'Other'],
  'Home & Garden': ['Kitchen & Dining', 'Bedding', 'Bath', 'Home Décor', 'Lighting', 'Storage', 'Other'],
  'Home & Kitchen': PRE_OWNED_ITEM_CATEGORY_DATA['Home & Kitchen'],
  Beauty: ['Makeup', 'Skin Care', 'Hair Care', 'Fragrance', 'Tools & Accessories', 'Other'],
  Baby: ['Clothing', 'Toys', 'Feeding', 'Nursery', 'Safety', 'Other'],
  'Pet Supplies': PET_SUPPLIES_SECTIONS,
};

const CLOTHING_CATEGORY_KEYWORDS = [
  'clothing',
  'footwear',
  'handbags',
  'accessories',
  'watches',
  'fashion',
  'shoes',
  'bridal',
  'groom',
  'suit',
  'dress',
  'apparel',
  'bags',
  'veil',
  'soiree',
  'bridesmaid',
];

export const EMPTY_BROWSE_FILTERS = {
  department: '',
  category: '',
  subcategory: '',
  condition: '',
  color: '',
  size: '',
  material: '',
  length: '',
  silhouette: '',
  vibe: '',
  train: '',
  weight_class: '',
  is_hijabi: '',
  brand: '',
  minPrice: '',
  maxPrice: '',
  search: '',
  book_subcategory: '',
  book_type: '',
  book_language: '',
  book_audience: '',
  pet_type: '',
  sort: '',
  view: '',
};

export function parseMultiFilterValue(raw) {
  if (!raw) return [];
  return String(raw)
    .split(',')
    .map((part) => part.trim())
    .filter(Boolean);
}

export function joinMultiFilterValue(values) {
  return values.filter(Boolean).join(',');
}

export function toggleMultiFilterValue(raw, value) {
  const current = parseMultiFilterValue(raw);
  if (current.includes(value)) {
    return joinMultiFilterValue(current.filter((entry) => entry !== value));
  }
  return joinMultiFilterValue([...current, value]);
}

export function isClothingCategory(category) {
  if (!category) return false;
  const normalized = category.toLowerCase();
  return CLOTHING_CATEGORY_KEYWORDS.some((keyword) => normalized.includes(keyword));
}

/** Size filter is shown on every browse page (web + app). */
export function showsBrowseSizeFilter(_category) {
  return true;
}

/** Deduped size options for browse filters. */
export function getBrowseSizeOptions(_category) {
  return Array.from(new Set(FILTER_CLOTHING_SIZES));
}

export function getSubcategoriesForCategory(category) {
  if (!category) return [];
  return BROWSE_CATEGORY_SUBCATEGORIES[category] || [];
}

export function buildBrowseFetchParams(filters, sort, extra = {}) {
  const params = { ...extra };
  Object.entries(filters || {}).forEach(([key, value]) => {
    if (value && key !== 'view') params[key] = String(value);
  });
  if (params.subcategory && params.category === 'Books') {
    params.book_subcategory = params.subcategory;
    delete params.subcategory;
  }
  const effectiveSort = sort === 'nearest' ? 'recommended' : sort;
  if (effectiveSort && effectiveSort !== 'recommended') {
    params.sort = effectiveSort;
  }
  if (extra.user_lat != null && extra.user_lon != null) {
    params.user_lat = String(extra.user_lat);
    params.user_lon = String(extra.user_lon);
  }
  return params;
}

export function toBrowseApiParams(filters) {
  const params = { ...filters };
  delete params.view;
  delete params.sort;
  if (params.subcategory && params.category === 'Books') {
    params.book_subcategory = params.subcategory;
    delete params.subcategory;
  }
  return params;
}

export const FILTER_LABELS = {
  department: 'Department',
  category: 'Category',
  subcategory: 'Subcategory',
  condition: 'Condition',
  color: 'Color',
  size: 'Size',
  material: 'Material',
  length: 'Length',
  silhouette: 'Silhouette',
  vibe: 'Overall style vibe',
  train: 'Train',
  weight_class: 'Weight',
  is_hijabi: 'Designed for',
  brand: 'Brand',
  minPrice: 'Min',
  maxPrice: 'Max',
  search: 'Search',
  book_subcategory: 'Book',
  book_type: 'Book type',
  book_language: 'Language',
  book_audience: 'Audience',
  pet_type: 'Pet type',
};
